import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MainRouter from "./MainRouter";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <React.StrictMode>
      <MainRouter />
    </React.StrictMode>
  </HelmetProvider>
);
